export default "__VITE_ASSET__DDOM0fal__";